'use client';

import { useEffect, useState } from 'react';

export const CONSENT_KEY = 'evtolto_cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(CONSENT_KEY);
      if (v !== 'ads' && v !== 'essential') setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const set = (value: 'ads' | 'essential') => {
    try {
      localStorage.setItem(CONSENT_KEY, value);
    } catch {
      /* ignore */
    }
    setVisible(false);
    window.dispatchEvent(new CustomEvent('evtolto-consent', { detail: value }));
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[90] border-t border-slate-200 bg-white/95 p-4 shadow-2xl backdrop-blur-md">
      <div className="mx-auto flex max-w-5xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm leading-relaxed text-slate-700">
          A térkép alapfunkciói sütik nélkül is működnek. A hirdetésekhez (Google AdSense) harmadik féltől
          származó sütik kellenek. Részletek:{' '}
          <a href="/adatkezelesi-tajekoztato" className="font-semibold text-emerald-700 underline">
            adatkezelési tájékoztató
          </a>
          .
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={() => set('essential')}
            className="rounded-lg border border-slate-300 px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
          >
            Csak szükséges
          </button>
          <button
            type="button"
            onClick={() => set('ads')}
            className="rounded-lg bg-emerald-700 px-3 py-2 text-sm font-semibold text-white hover:bg-emerald-800 transition"
          >
            Hirdetési sütik engedélyezése
          </button>
        </div>
      </div>
    </div>
  );
}
